import * as React from 'react'
import {useMemo} from 'react'

import type {ProjectId} from '../../../types'
import {ROOT_PROJECT_ID} from '../../../types'
import Loader from '../Loader/Loader'
import SequenceLoader, {SequenceLoaderChild} from '../SequenceLoader/SequenceLoader'

import {NestedContent} from './NestedSubprojectsAndBuildTypesContext'
import Subprojects from './Subprojects/Subprojects.container'

type OwnProps = {
  projectId: ProjectId
  hasSubprojectContent?: boolean
  level?: number
  onlyFavorites?: boolean
  projectsReady: boolean
  limitWidth?: boolean
}

const NestedSubprojectsAndBuildTypes = ({
  projectId,
  hasSubprojectContent = false,
  onlyFavorites = false,
  projectsReady,
  level = 0,
  limitWidth,
}: OwnProps) => {
  const isRoot = projectId === ROOT_PROJECT_ID

  return useMemo(
    () => (
      <SequenceLoader showFirstLoadingItem>
        {!isRoot && hasSubprojectContent ? (
          <SequenceLoaderChild seqKey="self">
            <NestedContent projectId={projectId} />
          </SequenceLoaderChild>
        ) : null}
        <SequenceLoaderChild seqKey="subprojects">
          {projectsReady ? (
            <Subprojects
              level={level}
              projectId={projectId}
              onlyFavorites={onlyFavorites}
              limitWidth={limitWidth}
            />
          ) : (
            <Loader />
          )}
        </SequenceLoaderChild>
      </SequenceLoader>
    ),
    [hasSubprojectContent, isRoot, level, onlyFavorites, projectId, projectsReady, limitWidth],
  )
}

export default NestedSubprojectsAndBuildTypes
